/**
 * Vault app Firebase bootstrap — authenticates against the SECONDARY project
 * (`secvault-vault-*`), NOT the advisor project.
 *
 * Every field falls back to the primary `VITE_FIREBASE_*` value when its
 * `VITE_VAULT_FIREBASE_*` counterpart is blank (emulator convenience). In prod the
 * api key + auth domain MUST be the real secondary-project web config or Firebase
 * throws `auth/invalid-api-key`. The empty-aware `coalesce` (not `??`) is what makes
 * a present-but-blank placeholder fall back instead of baking `apiKey: ""`.
 */
import {
  type FirebaseWebConfig,
  coalesce,
  initFirebaseAuth,
} from "@secure-vault/firebase-auth";

const env = import.meta.env;

const config: FirebaseWebConfig = {
  apiKey:
    coalesce(env.VITE_VAULT_FIREBASE_API_KEY, env.VITE_FIREBASE_API_KEY) ?? "",
  authDomain:
    coalesce(
      env.VITE_VAULT_FIREBASE_AUTH_DOMAIN,
      env.VITE_FIREBASE_AUTH_DOMAIN
    ) ?? "",
  projectId:
    coalesce(
      env.VITE_VAULT_FIREBASE_PROJECT_ID,
      env.VITE_FIREBASE_PROJECT_ID
    ) ?? "",
  storageBucket: coalesce(
    env.VITE_VAULT_FIREBASE_STORAGE_BUCKET,
    env.VITE_FIREBASE_STORAGE_BUCKET
  ),
  messagingSenderId: coalesce(
    env.VITE_VAULT_FIREBASE_MESSAGING_SENDER_ID,
    env.VITE_FIREBASE_MESSAGING_SENDER_ID
  ),
  appId: coalesce(env.VITE_VAULT_FIREBASE_APP_ID, env.VITE_FIREBASE_APP_ID),
};

const useEmulator =
  env.VITE_USE_EMULATOR === true || env.VITE_USE_EMULATOR === "true";
const emulatorHost = env.VITE_VAULT_AUTH_EMULATOR_HOST || "127.0.0.1:9098";

export const { app, auth } = initFirebaseAuth({
  name: "vault",
  config,
  useEmulator,
  emulatorHost,
});
